import { PushupSVG, FlexibilitySVG } from "./SVGIllustrations";
import { TextInput } from "@/components/we360/TextInput";
import { PillSelect } from "@/components/we360/PillSelect";
import { CalculatedBadge } from "@/components/we360/CalculatedBadge";
import { AlertBanner } from "@/components/we360/AlertBanner";
import { FLEX_OPTIONS, getFlexCategory } from "./helpers";

export default function Step5PushupsFlex({
  flexiones,
  onFlexionesChange,
  pushupClass,
  flexibilidad,
  onFlexibilidadChange,
  sex,
  isDefaultSex,
  errors,
  onBlur,
}) {
  const isFemale = /^femenino|^mujer|^female|^f$/i.test(String(sex || "").trim());
  const flexCategory = getFlexCategory(flexibilidad);

  return (
    <div>
      <div className="text-center mb-2">
        <PushupSVG reps={flexiones} sex={sex} />
      </div>

      {/* Push-ups section */}
      <div
        className="rounded-[14px] p-3 mb-4 text-xs leading-relaxed"
        style={{ background: "#FCFAEE", border: "1px solid #E2D9CB", color: "#2D2A24" }}
        data-testid="f2-pushup-instructions"
      >
        Realiza tantas flexiones completas como puedas sin pausa.
        {isFemale && (
          <span className="block mt-1 font-semibold" style={{ color: "#00628F" }}>
            Si eres mujer, puedes usar apoyo de rodillas (flexiones modificadas).
          </span>
        )}
      </div>

      <TextInput
        label="Repeticiones de flexiones"
        value={flexiones}
        onChange={onFlexionesChange}
        onBlur={() => onBlur?.("flexiones")}
        placeholder="15"
        suffix="reps"
        type="number"
        min="0"
        max="100"
        error={errors?.getError("flexiones")}
        testId="input-flexiones"
      />

      {pushupClass && (
        <>
          <CalculatedBadge
            label="Flexiones"
            value={`${flexiones}`}
            unit="reps"
            category={pushupClass.label}
            categoryColor={pushupClass.color}
            testId="badge-flexiones"
          />
          {isDefaultSex && (
            <AlertBanner variant="info" testId="alert-default-sex-pushup">
              Clasificacion usando valores de referencia generales.
            </AlertBanner>
          )}
        </>
      )}

      {/* Flexibility section */}
      <div className="mt-5 pt-4" style={{ borderTop: "1px solid #E2D9CB" }}>
        <div className="text-center mb-2">
          <FlexibilitySVG flexibilidad={flexibilidad} sex={sex} />
        </div>
        <div
          className="rounded-[14px] p-3 mb-3 text-xs leading-relaxed"
          style={{ background: "#FCFAEE", border: "1px solid #E2D9CB", color: "#2D2A24" }}
          data-testid="f2-flex-instructions"
        >
          <strong>Flexibilidad (Sit & Reach):</strong> Sentado/a en el suelo con las piernas estiradas,
          intenta tocar tus pies con las manos.
        </div>

        <PillSelect
          label="Resultado"
          options={FLEX_OPTIONS.map((o) => o.label)}
          value={flexCategory?.label || ""}
          onChange={(label) => {
            const opt = FLEX_OPTIONS.find((o) => o.label === label);
            if (opt) onFlexibilidadChange(opt.value);
          }}
          error={errors?.getError("flexibilidad")}
          testId="pill-flexibilidad"
        />

        {flexCategory && (
          <CalculatedBadge
            label="Flexibilidad"
            value={flexCategory.category}
            categoryColor={flexCategory.color}
            testId="badge-flexibilidad"
          />
        )}
      </div>
    </div>
  );
}
